export const environment = {
  apiUrl: 'https://api-ai-dev.digitaloilfield.app/api/v1',
  authUrl: 'https://digitaloilfield.app/api/v2/auth',
  prod: true,
  deploymentNames: ['doailabs-dev-gpt-4.1', 'doailabs-dev-gpt-4.1-mini'],
  deploymentApiVersions: ['2024-12-01-preview'],
};
